export const RESET = 'EXCMCASEPROBLEM_LIST_RESET'
export const SET_ITEMS = 'EXCMCASEPROBLEM_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCASEPROBLEM_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCASEPROBLEM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCASEPROBLEM_LIST_TOGGLE_LOADING'
